// Module
var code = "<div class=\"application-panel-container-table instrument-holidays-table\" style=\"height: {{tableHeight}}px;\">\r\n    <terceraPanel name='windowPanelBodyQT' />\r\n</div>";
// Exports
export default code;